import * as PropTypes from 'prop-types';
import * as React from 'react';
import AjaxMultiAddToCartButton from './ajax_multi_add_to_cart_button';

// Wrapper around AjaxMultiAddToCartButton
// * takes a single product id instead of multiple
// * instead of taking an onError callback, will render the
//   error in place.
class StandaloneAjaxAddToCartButton extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      errorMessage: null,
    };

    this.handleError = this.handleError.bind(this);
  }

  handleError(errorMessage) {
    this.setState({ errorMessage });
  }

  render() {
    if (this.state.errorMessage) {
      return <div className="alert alert-error mb-1">{this.state.errorMessage}</div>;
    }

    return (
      <AjaxMultiAddToCartButton
        listingIds={[this.props.productId]}
        onError={this.handleError}
        text={this.props.text}
        isOwner={this.props.isOwner}
        onPreorder={this.props.onPreorder}
        aid={this.props.aid}
        source={this.props.source}
        zeroPercentAffirmFinancing={this.props.zeroPercentAffirmFinancing}
        trackName={this.props.trackName}
      />
    );
  }
}

StandaloneAjaxAddToCartButton.propTypes = {
  productId: PropTypes.number.isRequired,
  text: PropTypes.string,
  isOwner: PropTypes.bool,
  onPreorder: PropTypes.bool,
  aid: PropTypes.string,
  source: PropTypes.string,
  zeroPercentAffirmFinancing: PropTypes.bool,
  trackName: PropTypes.string,
};

StandaloneAjaxAddToCartButton.defaultProps = {
  aid: '',
  isOwner: false,
  onPreorder: false,
  source: '',
  text: '',
  trackName: 'add_to_cart',
  zeroPercentAffirmFinancing: false,
};

export default StandaloneAjaxAddToCartButton;



// WEBPACK FOOTER //
// ./javascripts/components/listings/cart/standalone_ajax_add_to_cart_button.jsx